import { render, staticRenderFns } from "./typeUser.vue?vue&type=template&id=6368f9d5&scoped=true"
import script from "./typeUser.vue?vue&type=script&lang=js"
export * from "./typeUser.vue?vue&type=script&lang=js"
import style0 from "./typeUser.vue?vue&type=style&index=0&id=6368f9d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368f9d5",
  null
  
)

export default component.exports